import React from 'react';

import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { usePlatformBillingInformationQuery } from '@dashboard/generated/wp/platform';
import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { Stack, Typography } from '@mui/material';

import BillingEmailAddressForm from './BillingEmailAddressForm';
import BillingPlanForm from './BillingPlanForm';
import UsageReport from './UsageReport';

export default function BillingConfigurationEdit(): JsxNode {
  const { data: platformData } = useCurrentWpPlatform();
  const { data } = usePlatformBillingInformationQuery();
  const BILLING_HELP_URL = 'https://www.usewaypoint.com/docs/manage-plan';
  const p = data?.PlatformBillingInformation;

  const environment = platformData?.Platform.environment;

  if (p === undefined || environment === undefined) {
    return <BaseSettingCard helpUrl={BILLING_HELP_URL} title="Billing" />;
  }
  if (environment === 'SANDBOX') {
    return (
      <BaseSettingCard helpUrl={BILLING_HELP_URL} title="Billing">
        <Typography>
          This is a sandbox workspace. If you're looking for billing and plans information visit the Settings page in
          your live workspace.
        </Typography>
      </BaseSettingCard>
    );
  }

  return (
    <BaseSettingCard helpUrl={BILLING_HELP_URL} title="Billing">
      <Stack spacing={3}>
        <BillingEmailAddressForm initialValues={{ billingEmailAddress: p.billingEmailAddress! }} />
        <BillingPlanForm tier={p.activeWaypointTier} />
        <UsageReport />
      </Stack>
    </BaseSettingCard>
  );
}
